module.exports = __webpack_public_path__ + "bg.1pDdxN2P.svg";